
import { Message, Conversation, Product } from '../types';
import { getStoreAssistantReply } from './geminiService';

const STORAGE_KEY = 'lynqar_conversations';

export const chatService = {
  getConversations: (): Conversation[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  },

  getStoreConversations: (storeId: string): Conversation[] => {
    return chatService.getConversations().filter(c => c.storeId === storeId);
  },

  getCustomerConversation: (customerId: string, storeId: string): Conversation | null => {
    return chatService.getConversations().find(c => c.customerId === customerId && c.storeId === storeId) || null;
  },

  sendMessage: async (
    senderId: string, 
    receiverId: string, 
    text: string, 
    storeName?: string, 
    inventory?: Product[]
  ): Promise<Message> => {
    const isCustomer = !senderId.startsWith('store-');
    const customerId = isCustomer ? senderId : receiverId;
    const storeId = isCustomer ? receiverId : senderId;

    const newMessage: Message = {
      id: 'msg-' + Date.now(),
      senderId,
      receiverId,
      text,
      timestamp: new Date().toISOString()
    };

    const conversations = chatService.getConversations();
    let conv = conversations.find(c => c.customerId === customerId && c.storeId === storeId);

    if (conv) {
      conv.messages.push(newMessage);
      conv.lastMessageAt = newMessage.timestamp;
    } else {
      conv = {
        id: 'conv-' + Date.now(),
        customerId,
        storeId,
        messages: [newMessage],
        lastMessageAt: newMessage.timestamp
      };
      conversations.push(conv);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
    window.dispatchEvent(new Event('chat-update'));

    // Trigger AI response if customer sends message and no vendor is online
    if (isCustomer && inventory && storeName) {
      setTimeout(async () => {
        const aiText = await getStoreAssistantReply(text, inventory, storeName);
        const aiMessage: Message = {
          id: 'ai-' + Date.now(),
          senderId: storeId,
          receiverId: customerId,
          text: aiText || "I'll let the owner know you're asking about this.",
          isAi: true,
          timestamp: new Date().toISOString()
        };
        
        const latestConvs = chatService.getConversations();
        const activeConv = latestConvs.find(c => c.customerId === customerId && c.storeId === storeId);
        if (activeConv) {
          activeConv.messages.push(aiMessage);
          activeConv.lastMessageAt = aiMessage.timestamp;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(latestConvs));
          window.dispatchEvent(new Event('chat-update'));
        }
      }, 1500);
    }

    return newMessage;
  },

  onChatUpdate: (callback: () => void) => {
    window.addEventListener('chat-update', callback);
    return () => window.removeEventListener('chat-update', callback);
  }
};
